import { render } from "./TimelineLabel.vue?vue&type=template&id=18d5b0bc"
import script from "./TimelineLabel.vue?vue&type=script&lang=js"
export * from "./TimelineLabel.vue?vue&type=script&lang=js"

import "./TimelineLabel.vue?vue&type=style&index=0&id=18d5b0bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__